import {Injectable} from '@angular/core';
import {BehaviorSubject} from 'rxjs';

@Injectable({
  providedIn: "root"
})
export class DataService {
  constructor() {}

  private viewCheckedEvent = new BehaviorSubject<string>("");

  emitViewChecked() {
    this.viewCheckedEvent.next(null);
  }

  viewCheckedEventListener() {
    return this.viewCheckedEvent.asObservable();
  }
}
